/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

class MatchHeight {
  constructor($el, opts) {
    this.defaults = {
      timeout: 250
    };
    this.options = Object.assign(this.defaults, opts);
    this.$els = document.querySelectorAll($el);
    this.$elsArray = Array.prototype.slice.call(this.$els);
    this.getAndSet(this.$elsArray);
    this.debounceHeight = this.debounce(() => {
      this.getAndSet(this.$elsArray);
    }, this.options.timeout);
    window.addEventListener('resize', () => {
      this.debounceHeight();
    });
  }

  getAndSet($elsArray) {
    $elsArray.forEach($el => $el.removeAttribute('style'));
    const height = Math.max(...$elsArray.map(o => o.clientHeight));
    $elsArray.forEach(($el) => {
      Object.assign($el.style, { height: `${height}px`, verticalAlign: 'top' });
    });
  }

  debounce(func, wait, immediate) {
    let timeout;
    return () => {
      const context = this;
      const args = arguments;
      const later = () => {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
}

document.addEventListener("DOMContentLoaded", function(event) { 
  // var customFeaturedCollectionItems = document.querySelectorAll('.custom-featured-collection-grid-item');
  // var customFeaturedCollectionItemsContents = document.querySelectorAll('.custom-featured-collection-grid-item-content');
  // if (customFeaturedCollectionItems.length) {
  //   customFeaturedCollectionItems.forEach(function(item){
  //     item.addEventListener("mouseenter", function(e) {
  //       customFeaturedCollectionItemsContents.forEach(function(el){
  //         el.classList.remove('show');
  //       });
  //       var id = this.getAttribute('data-id');
  //       var itemContent = document.querySelector('.custom-featured-collection-grid-item-content[data-id="' + id + '"]');
  //       if (itemContent != null) {
  //         itemContent.classList.add('show');
  //       }
  //     });
  //   })
  // }

  var customAccordionsShort = document.querySelectorAll('.custom-accordion-content-short');
  if (customAccordionsShort.length) {
    customAccordionsShort.forEach(function(item){
      var itemHeight = item.offsetHeight;
      var itemMainDescription = item.closest('.custom-accordion').querySelector('.custom-accordion-content-main');
      if (itemMainDescription != null) {
        itemMainDescription.style.maxHeight = itemHeight + 'px';
        itemMainDescription.setAttribute('data-max-height', itemHeight + 'px');
      }
    });
  }

  var customActiveAccordions = document.querySelectorAll('.custom-accordion.active');
  if (customActiveAccordions.length) {
    customActiveAccordions.forEach(function(item){
      var itemPanel = item.querySelector('.custom-accordion-content-main');
      itemPanel.style.maxHeight = itemPanel.scrollHeight + "px";;
    });
  }

  window.addEventListener("resize", function() {
    if (customAccordionsShort.length) {
      customAccordionsShort.forEach(function(item){
        var itemHeight = item.offsetHeight;
        var itemMainDescription = item.closest('.custom-accordion').querySelector('.custom-accordion-content-main');
        if (itemMainDescription != null) {
          itemMainDescription.style.maxHeight = itemHeight + 'px';
          itemMainDescription.setAttribute('data-max-height', itemHeight + 'px');
        }
      });
    }
  });

  var customAccordionsButtons = document.querySelectorAll('.custom-accordion-button');
 
  for (var i = 0; i < customAccordionsButtons.length; i++) {
    customAccordionsButtons[i].addEventListener("click", function() {
      var _this = this;
      var itemParent = this.closest('.custom-accordion');
      var itemsParent = this.closest('.custom-accordions-section-content');
      var sectionParent = this.closest('.custom-accordions-section');
      var sectionImages = sectionParent.querySelectorAll('.custom-accordions-section-image img');
      var accordionsPanels = itemsParent.querySelectorAll('.custom-accordion-content-main');
      var accordions = itemsParent.querySelectorAll('.custom-accordion');
      accordionsPanels.forEach(function(item){
        var itemMaxHeight = item.getAttribute('data-max-height');
        item.style.maxHeight = itemMaxHeight;
      });
      accordions.forEach(function(item){
        if (itemParent != item) {
          item.classList.remove("active");
        }
      });

      sectionImages.forEach(function(item){
        if (_this.getAttribute('data-id') == item.getAttribute('data-id')) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
      
      itemParent.classList.toggle("active");
   
      var accordionPanel = itemParent.querySelector('.custom-accordion-content-main');
      var accordionPanelMaxHeight = accordionPanel.getAttribute('data-max-height');
      if (!itemParent.classList.contains('active')) {
        accordionPanel.style.maxHeight = accordionPanelMaxHeight;
      } else {
        accordionPanel.style.maxHeight = accordionPanel.scrollHeight + "px";
      }
    });
  }

  var customCollectionsSliders = document.querySelectorAll('.custom-collections-section-nav-collections-item');
  if (customCollectionsSliders.length) {
    customCollectionsSliders.forEach(function(item){
      if (item.classList.contains('active')) {
        var customCollectionFlkty = new themeVendor.Flickity( item, {
          cellAlign: 'left',
          contain: true,
          prevNextButtons: true,
          wrapAround: true,
          pageDots: false
        });
      }
    });
  }

  var customCollectionNavItems = document.querySelectorAll('.custom-collections-section-nav-item-checkbox');
  var customCollectionItemsContents = document.querySelectorAll('.custom-collections-section-nav-collections-item');
  if (customCollectionNavItems.length) {
    customCollectionNavItems.forEach(function(item){
      item.addEventListener("click", function(e) {
        customCollectionItemsContents.forEach(function(el){
          el.classList.remove('active');
        });
        customCollectionNavItems.forEach(function(el){
          el.classList.remove('active');
        });
        
        this.classList.add('active');
        var id = this.getAttribute('data-id');
        var itemContent = document.querySelector('.custom-collections-section-nav-collections-item[data-id="' + id + '"]');
        if (itemContent != null) {
          itemContent.classList.add('active');
          var customCollectionFlkty = new themeVendor.Flickity( itemContent, {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: true,
            wrapAround: true,
            pageDots: false
          });
        }
      });
    })
  }

  var blogSectionsSliders = document.querySelectorAll('.blog-listing-layout--carousel');
  if (blogSectionsSliders.length) {
    blogSectionsSliders.forEach(function(item){
      var buttonPerv = item.closest('.blog-section').querySelector('.slider-button-prev');
      var buttonNext = item.closest('.blog-section').querySelector('.slider-button-next');
      var blogFlkty = new themeVendor.Flickity( item, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        wrapAround: true,
        pageDots: false
      });

      if (buttonPerv != null) {
        buttonPerv.addEventListener('click', function() {
          blogFlkty.previous();
        });
      }

      if (buttonNext != null) {
        buttonNext.addEventListener('click', function() {
          blogFlkty.next();
        });
      }
      setTimeout(function(){
      blogFlkty.reloadCells();
      blogFlkty.reposition();
      blogFlkty.resize();
      },1000);
      
      
    });
  }

  var footerAccordions = document.querySelectorAll('.footer__block__title_mobile_button');
 
  for (var i = 0; i < footerAccordions.length; i++) {
    footerAccordions[i].addEventListener("click", function() {
      this.classList.toggle("active");
   
      var accordionPanel = this.nextElementSibling;
      if (accordionPanel.style.maxHeight) {
        accordionPanel.style.maxHeight = null;
      } else {
        accordionPanel.style.maxHeight = accordionPanel.scrollHeight + "px";
      }
    });
  }

  const matchHeight = new MatchHeight('.blog-section-home .article .article__text-wrapper');

  var productTechnologySectionLine1 = document.querySelector('.product_technology_section_grid_image_line.line_1');
  var productTechnologySectionLine2 = document.querySelector('.product_technology_section_grid_image_line.line_2');
  var productTechnologySectionLine3 = document.querySelector('.product_technology_section_grid_image_line.line_3');
  var productTechnologySectionTextBlock1 = document.querySelector('.product_technology_section_grid_content_item:nth-child(1)');
  var productTechnologySectionTextBlock2 = document.querySelector('.product_technology_section_grid_content_item:nth-child(2)');
  var productTechnologySectionTextBlock3 = document.querySelector('.product_technology_section_grid_content_item:nth-child(3)');

  if (productTechnologySectionLine1 != null && productTechnologySectionTextBlock3 != null) {
    productTechnologySectionLine1.style.height = productTechnologySectionTextBlock3.getBoundingClientRect().top - productTechnologySectionLine1.getBoundingClientRect().top + 11 + 'px';
  }

  if (productTechnologySectionLine2 != null && productTechnologySectionTextBlock2 != null) {
    productTechnologySectionLine2.style.height = productTechnologySectionTextBlock2.getBoundingClientRect().top - productTechnologySectionLine2.getBoundingClientRect().top + 11 + 'px';
  }

  if (productTechnologySectionLine3 != null && productTechnologySectionTextBlock1 != null) {
    productTechnologySectionLine3.style.height = productTechnologySectionTextBlock1.getBoundingClientRect().top - productTechnologySectionLine3.getBoundingClientRect().top + 11 + 'px';
  }

  window.addEventListener("resize", function() {
    if (productTechnologySectionLine1 != null && productTechnologySectionTextBlock3 != null) {
      productTechnologySectionLine1.style.height = productTechnologySectionTextBlock3.getBoundingClientRect().top - productTechnologySectionLine1.getBoundingClientRect().top + 11 + 'px';
    }
  
    if (productTechnologySectionLine2 != null && productTechnologySectionTextBlock2 != null) {
      productTechnologySectionLine2.style.height = productTechnologySectionTextBlock2.getBoundingClientRect().top - productTechnologySectionLine2.getBoundingClientRect().top + 11 + 'px';
    }
  
    if (productTechnologySectionLine3 != null && productTechnologySectionTextBlock1 != null) {
      productTechnologySectionLine3.style.height = productTechnologySectionTextBlock1.getBoundingClientRect().top - productTechnologySectionLine3.getBoundingClientRect().top + 11 + 'px';
    }
  });

  var blogTagsGroupItems = document.querySelectorAll('.blog-page-custom-nav-item');
  var blogTagsBlockItems = document.querySelectorAll('.product-page-tags-nav');

  if (blogTagsGroupItems.length) {
    blogTagsGroupItems.forEach(function(item){
      item.addEventListener("click", function(e) {
        blogTagsBlockItems.forEach(function(el){
          el.classList.remove('active');
        });
        blogTagsGroupItems.forEach(function(el){
          el.classList.remove('active');
        });
        
        this.classList.add('active');
        var id = this.getAttribute('data-tags-group');
        var blogTagsBlockActive = document.querySelector('.product-page-tags-nav[data-tags-group="' + id + '"]');
        if (blogTagsBlockActive != null) {
          blogTagsBlockActive.classList.add('active');
        }
      });
    })
  }

  var aboutUsPageNavLinks = document.querySelectorAll('.about-us-page-nav-item');
  if (aboutUsPageNavLinks.length) {
    aboutUsPageNavLinks.forEach(function(item){
      item.addEventListener("click", function(e) {
        aboutUsPageNavLinks.forEach(function(el){
          el.classList.remove('active');
        });
        
        this.classList.add('active');
      });
    })
  }

  var customFeturedCollections = document.querySelectorAll('.custom-featured-collection-grid');
  if (customFeturedCollections.length) {
    customFeturedCollections.forEach(function(item){
      var customFeturedCollectionsFlkty = new themeVendor.Flickity( item, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        wrapAround: false,
        pageDots: false,
        watchCSS: true,
        wrapAround: true,
         arrowShape: { 
            x0: 10,
            x1: 60, y1: 50,
            x2: 65, y2: 45,
            x3: 20
        }
      });

       setTimeout(function(){
      customFeturedCollectionsFlkty.reloadCells();
      customFeturedCollectionsFlkty.reposition();
      customFeturedCollectionsFlkty.resize();
      },1000);
      
    })
  }
});
